import {
  GET_COMMUNE_ERR,
  GET_COMMUNE_OK,
  DELETE_COMMUNE_ERR,
  DELETE_COMMUNE_OK,
  CREATE_COMMUNE_ERR,
  UPD_COMMUNE_ERR,
  UPD_COMMUNE_OK,
} from "./commune.action";

const InitState = {
  error: null,
  content: null,
};

export default function CommuneAdmReducer(state = InitState, action) {
  switch (action.type) {
    case GET_COMMUNE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_COMMUNE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    case DELETE_COMMUNE_OK: {
      const id = action.payload.Id;
      return {
        ...state,
        error: null,
        content: {
          items: state.content.items.filter((item) => item.id !== id),
        },
      };
    }
    case DELETE_COMMUNE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    case CREATE_COMMUNE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    case UPD_COMMUNE_OK: {
      const itemParameter = action.payload;
      return {
        ...state,
        content: {
          items: state.content.items.map((item) =>
            item.id === itemParameter.id
              ? // transform the one with a matching id
                {
                  ...item,
                  name: itemParameter.name,
                  districtId: itemParameter.districtId,
                  districtName: itemParameter.districtName,
                  provinceId: itemParameter.provinceId,
                  provinceName: itemParameter.provinceName,
                }
              : // otherwise return original todo
                item
          ),
        },
      };
    }
    case UPD_COMMUNE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    default:
      return state;
  }
}
